/**
 * Pure helpers for the default-products list on the Stores page: defaults are
 * per ingredient and per store, with an "any store" row as the fallback.
 */
import type { DefaultProductDto } from '@fewerbags/schema';

/** The selector value for the household's any-store defaults. */
export const ANY_STORE = 'any';

/** "Any store" first, then every store that has a default of its own, by name. */
export function defaultStoreOptions(
  defaults: readonly Pick<DefaultProductDto, 'storeId' | 'storeName'>[],
): Array<{ value: string; label: string }> {
  const stores = new Map<string, string>();
  for (const d of defaults) {
    if (d.storeId) stores.set(d.storeId, d.storeName ?? 'Store');
  }
  const named = [...stores.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
  return [{ value: ANY_STORE, label: 'Any store' }, ...named];
}

/** The defaults that apply to one selector value. */
export function defaultsForStore<T extends Pick<DefaultProductDto, 'storeId'>>(
  defaults: readonly T[],
  selected: string,
): T[] {
  return defaults.filter((d) =>
    selected === ANY_STORE ? d.storeId === null : d.storeId === selected,
  );
}
